import Icon from '../components/Icon.vue'

Icon.register({
  'grip-horizontal': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M96 288H32C14.3 288 0 302.3 0 320V384C0 401.7 14.3 416 32 416H96C113.7 416 128 401.7 128 384V320C128 302.3 113.7 288 96 288zM256 288H192C174.3 288 160 302.3 160 320V384C160 401.7 174.3 416 192 416H256C273.7 416 288 401.7 288 384V320C288 302.3 273.7 288 256 288zM416 288H352C334.3 288 320 302.3 320 320V384C320 401.7 334.3 416 352 416H416C433.7 416 448 401.7 448 384V320C448 302.3 433.7 288 416 288zM96 96H32C14.3 96 0 110.3 0 128V192C0 209.7 14.3 224 32 224H96C113.7 224 128 209.7 128 192V128C128 110.3 113.7 96 96 96zM256 96H192C174.3 96 160 110.3 160 128V192C160 209.7 174.3 224 192 224H256C273.7 224 288 209.7 288 192V128C288 110.3 273.7 96 256 96zM416 96H352C334.3 96 320 110.3 320 128V192C320 209.7 334.3 224 352 224H416C433.7 224 448 209.7 448 192V128C448 110.3 433.7 96 416 96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grip-horizontal.js
// module id = CVCY
// module chunks = 144